import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanyApi } from '@app/services/company-api';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/type-options';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { SubscriptionInterface } from '@app/interface/subscription';
import { Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Organizations } from '@app/interface/organizations';
import { PaymentInterface } from '@app/interface/payment';

export interface viewPaymentDialogData {
  payment: PaymentInterface;
  organizationId: number;
  organization: Organizations;
}

@Component({
  selector: 'izy-view-payment-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
  ],
  templateUrl: './view-payment-dialog.component.html',
  styleUrl: './view-payment-dialog.component.scss',
})
export class ViewPaymentDialogComponent {
  showDelay = new FormControl(700);
  hideDelay = new FormControl(1000);
  paymentForm: FormGroup;
  isLoading = false;

  invoicingEmail: string = 'info@izysrl.it';
  external_link: string = '';

  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ViewPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: viewPaymentDialogData,
  ) {
    this.paymentForm = new FormGroup({
      external_link: new FormControl(''),
      invoicing_email: new FormControl(''),
    });
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
    if (this.data.payment) {
      this.paymentForm.patchValue({
        external_link: this.data.payment.external_link,
      });
    }

    if (this.data.organization) {
      this.external_link = this.data.payment.external_link;
    }

    if (this.data.organization) {
      this.invoicingEmail = this.data.organization.invoicing_email;
    }
  }

  getActiveValueDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      COMPLETED: 'COMPLETATO',
      REFUNDED: 'RIMBORSATO',
      PENDING: 'IN ATTESA',
      FAILED: 'FALLITO',
    };

    return statusMap[value] || 'Non specificato';
  }

  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.external_link)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(true); // Close with success

        this.showSuccessMessage('Link copiato negli appunti.');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  openPaymentAttachment(attachmentUrl: string | undefined): void {
    if (attachmentUrl) {
      // Open the attachment in a new tab
      window.open(attachmentUrl, '_blank');
    } else {
      // Optional: Show a message or handle the missing URL
      this.showErrorMessage('Nessun allegato disponibile');
    }
  }

  confirm(): void {
    if (this.paymentForm.valid) {
      this.dialogRef.close(this.paymentForm.value);
    }
  }

  onToggleChange(event: any): void {
    console.log('Auto-renew changed to:', event.checked);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
  }
}
